import type {
  createStylesParams,
  createSettingsParams,
  StyleParamType,
  SettingsParamType,
} from '@wix/tpa-settings'

export type StylesParamsType<T extends Record<string, StyleParamType>> = ReturnType<
  typeof createStylesParams<T>
>
export type SettingsParamsType<T extends Record<string, SettingsParamType>> = ReturnType<
  typeof createSettingsParams<T>
>

export enum TextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

export enum ButtonAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Stretch = 'Stretch',
}

export enum FormLayout {
  Packed = 'packed',
  Strip = 'strip',
}

// Tools for converting settingsParams to styleParams

export enum Alignment {
  Left = 1,
  Center = 2,
  Right = 3,
  Stretch = 4,
}

export const AlignmentToTextAlign: Record<Exclude<Alignment, Alignment.Stretch>, string> = {
  [Alignment.Left]: 'left',
  [Alignment.Center]: 'center',
  [Alignment.Right]: 'right',
}

export const AlignmentToJustifyContent: Record<Alignment, string> = {
  [Alignment.Left]: 'left',
  [Alignment.Center]: 'center',
  [Alignment.Right]: 'right',
  [Alignment.Stretch]: 'stretch',
}

export const AlignmentToAlignItems: Record<Alignment, string> = {
  [Alignment.Left]: 'start',
  [Alignment.Center]: 'center',
  [Alignment.Right]: 'end',
  [Alignment.Stretch]: 'initial',
}

export enum Direction {
  Normal = 1,
  Reverse = 2,
}

export const DirectionToFlexDirection: Record<Direction, string> = {
  [Direction.Normal]: 'row',
  [Direction.Reverse]: 'row-reverse',
}

export enum ImageSize {
  Crop = 1,
  Fit = 2,
}

export const ImageSizeToBackgroundSize: Record<ImageSize, string> = {
  [ImageSize.Crop]: 'cover',
  [ImageSize.Fit]: 'contain',
}
